import {createElement, PropTypes} from 'rlink-react';
import {DISCLAIMER} from 'rlink-shop/messages';
import {ContentImg} from 'rlink-repos/content-components';

export default function PurchaseModal ({css, content, ratingsBoard}) {
  let iframeOnLoad = () => {
    let elements = document.getElementsByClassName(css['ajax-loader']);
    for (let i = 0; i < elements.length; i++) {
      elements.item(i).remove();
    }
  };
  return (<div className={css['purchase-modal-wrapper']}>
    <div className={css['purchase-modal-content']}>
      <div className={css['ajax-loader']} />
      {(content) && <iframe {...content.props} onLoad={iframeOnLoad()} />}
    </div>
    <div className={css.legal}>
      {(ratingsBoard)
        ? <div className={css.rating}>
          <ContentImg src={ratingsBoard.imagePath} />
          {ratingsBoard.ratingReasons && ratingsBoard.ratingReasons.map(contentDescriptor => <div key={contentDescriptor.reason} className={css.reason}>{contentDescriptor.reason}</div>)}
        </div>
        : []
      }
      <p className={css.disclaimer}>
        {DISCLAIMER}
      </p>
    </div>
  </div>);
}

PurchaseModal.propTypes = {
  css: PropTypes.object,
  content: PropTypes.node,
  ratingsBoard: PropTypes.object,
};



// WEBPACK FOOTER //
// ./lib/rlink-shop/components/PurchaseModal.jsx